import styled from 'styled-components';
var Wrap = styled.div.withConfig({
  displayName: "Wrap",
  componentId: "o78u9m-0"
})(["white-space:nowrap;> *{display:inline-block;white-space:normal;}"]);
export default Wrap;